import { render, staticRenderFns } from "./AlertSet.vue?vue&type=template&id=1293b495&scoped=true"
import script from "./AlertSet.vue?vue&type=script&lang=js"
export * from "./AlertSet.vue?vue&type=script&lang=js"
import style0 from "./AlertSet.vue?vue&type=style&index=0&id=1293b495&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1293b495",
  null
  
)

export default component.exports